export interface SparklineProps {
  data: number[];
  w?: number | string;
  h?: number;
  color?: string;
  fill?: string;
  strokeWidth?: number;
  className?: string;
}

export function Sparkline({
  data,
  w = 100,
  h = 28,
  color = 'currentColor',
  fill = 'none',
  strokeWidth = 1.5,
  className,
}: SparklineProps) {
  if (!data || data.length === 0) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const responsive = typeof w === 'string';
  const vbW = responsive ? 100 : (w as number);
  const step = vbW / Math.max(1, data.length - 1);
  const pts = data.map<[number, number]>((v, i) => [
    i * step,
    h - ((v - min) / range) * (h - 4) - 2,
  ]);
  const d = 'M ' + pts.map(p => p.join(',')).join(' L ');
  const area = fill !== 'none' ? `${d} L ${vbW},${h} L 0,${h} Z` : null;
  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${vbW} ${h}`}
      preserveAspectRatio={responsive ? 'none' : 'xMidYMid meet'}
      className={className}
      style={{ display: 'block' }}
    >
      {area && <path d={area} fill={fill} />}
      <path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}

Sparkline.displayName = 'Sparkline';

export default Sparkline;
